import axios from "axios";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../AuthContext";
import { DATABOOK_API } from "../../constants/serverConfig";
import { AiFillLike } from "react-icons/ai";
import { IconContext } from "react-icons/lib";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

const DatasetLikes = (props) => {
  const { getToken, token } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  // const [star, setStar] = useState(0);

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 14,
      }}
      spin
    />
  );
  const datasetLikeCounter = async (fqn) => {
    setLoading(true);

    (async () => await getToken())();
    if (token) {
      await axios
        .patch(
          `${DATABOOK_API}/datasets/likes/${fqn}`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          let updatedRecord = res.data;
          props.updateFilterData(updatedRecord?.fqn, updatedRecord?.likesCount);
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  };
  return (
    // <div className="d-flex float-end pe-5">
    <div className="d-flex" style={{ border: "0px solid gray" }} >
      <div className="d-inline-blockk p-1">
        <IconContext.Provider
          value={{ color: props.likeColor ? "#42B0D5" : "grey", size: "20" }}
        >
          <div
            className="dataset-likes"
            onClick={() => datasetLikeCounter(props.fqn)}
          >
            <AiFillLike />
          </div>
        </IconContext.Provider>
        {/* <Rating
          name="dataset-likes"
          value={star}
          onChange={(event, newValue) => {
            setStar(newValue);
            datasetLikeCounter(props.fqn);
          }}
        /> */}
      </div>
      <div className="d-inline-blockk p-1 pt-2 antd-spin-width-cont">
        <span>
          {loading ? (
            <Spin indicator={antIcon} />
          ) : props.likesCount === null ? (
            0
          ) : (
            props.likesCount
          )}
        </span>
      </div>
    </div>
  );
};

export default DatasetLikes;
